// extracted by mini-css-extract-plugin
module.exports = {"uid":"u001243eb"};